/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { coreService } from 'network-utils';

export const getUserSkillTree = 'user-skill-tree';
export const getSkillTrees = 'skill-trees';

export const useGetUserSkillTree = (
    skillTreeUuid: string | null,
    selectedLearningPathUuid: string | null,
    token: string
) => {
    return useQuery(
        [getUserSkillTree, skillTreeUuid, selectedLearningPathUuid, token],
        () => coreService.skillTreeApi.getUserSkillTree(String(skillTreeUuid), selectedLearningPathUuid, token),
        {
            enabled: !!skillTreeUuid && !!token,
            keepPreviousData: true
        }
    );
};

export const useGetSkillTrees = (token: string) => {
    return useQuery([getSkillTrees, token], () => coreService.skillTreeApi.getSkillTrees(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};
